export enum CuroAppRoute {
  Home = '/',
  MailOffer = '/mail-offer',
  MailOfferNextSteps = '/mail-offer-next-steps',
  ApplyProcess = '/apply-process',
  SignIn = '/sign-in',
  ResumeProcess = '/application-process',
  TermsAndConditions = '/terms-and-conditions',
  ConsentForElectronicSignatures = '/terms-and-conditions/consent-for-electronic-signatures',
  TermsOfUse = '/terms-and-conditions/terms-of-use',
  OnlinePrivacyPolicy = '/terms-and-conditions/online-privacy-policy',
  PrivacyNotice = '/terms-and-conditions/privacy-notice',
  GeneralDisclosures = '/terms-and-conditions/genereal-disclosures',
  NotFound = '/not-found',
  Logout = '/logout',
}
